import { render, staticRenderFns } from "./RoomConfig.vue?vue&type=template&id=1805cb77&scoped=true"
import script from "./RoomConfig.vue?vue&type=script&lang=js"
export * from "./RoomConfig.vue?vue&type=script&lang=js"
import style0 from "./RoomConfig.vue?vue&type=style&index=0&id=1805cb77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805cb77",
  null
  
)

export default component.exports